<script setup lang="ts">

import {StackLayer} from "@/view-managers/stack/types";
import {onMounted, ref} from "vue";
import {Icon} from "@hantera/design-system";

const props = defineProps<{
  layer: StackLayer
}>()

const emit = defineEmits<{
  (ev: 'select', layer: StackLayer): void
}>()

const previewElem = ref<HTMLDivElement>()

onMounted(() => {
  if(!props.layer.element || !previewElem.value) {
    return
  }
  
  const clone = props.layer.element.cloneNode(true)
  previewElem.value?.append(...Array.from(clone.childNodes))
})

function select() {
  emit('select', props.layer)
}

function close() {
  props.layer.viewContext.close()
}

</script>

<template>
  <div
    class="list-item" @click="select"
    :class="{
      'selected': layer.viewContext.active
    }"
  >
    <div class="margin">
      <div class="preview-container">
        <div class="preview" ref="previewElem"></div>
      </div>

      <button class="btn-danger close" @click.stop.prevent="close">
        <Icon name="close"/>
      </button>
    </div>
    <div class="name">
      {{layer.viewContext.name}}
    </div>
  </div>
</template>

<style scoped>

.preview {
  position: absolute;
  width: 100vw;
  height: 100vw;
  transform: scale(40%);
  transform-origin: 0 0;
  overflow: hidden;
}

.margin {
  position: relative;
  width: calc(40vw);
  height: calc(40vw);
}

.preview-container {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  border: 1px solid hsl(var(--color-60));
  border-radius: 10px;
  background-color: hsl(var(--color-100));
  pointer-events: none;
}

.list-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}

.selected .preview-container {
  border-color: hsl(var(--color-primary));
}

.list-item:hover .preview-container {
  border-color: hsl(var(--color-primary));
}

.close {
  pointer-events: all;
  position: absolute;
  top: -16px;
  right: -16px;
  border-radius: 50%;
  width: 32px;
  height: 32px;
}

.close :deep(svg) {
  width: 16px;
}

</style>